const styles = {
  root: {
    paddingLeft: '0',
  },
};

export default styles;
